export const listHeaderName = {
  clientName: 'Client Name',
  agents: '# Agents',
  totalTpvs: 'Total TPVs',
  totalIvrMins: 'Total IVR Mins',
  totalLiveAgentMins: 'Total Live Agent Mins',
  textTPvs: 'Text TPVs',
  enrollments: 'Enrollments',
  contractSent: 'Contract Sent',
  imageUploaded: 'Image Uploaded',
  totalTexts: 'Total Texts',
}
